module.exports = __webpack_public_path__ + "img/__icono emitir certificados.2bbfcc8f.png";